import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import Amplify from '@aws-amplify/auth';
//
import 'zone.js';
// import awsconfig from './aws-exports';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

Amplify.configure({
  Auth: {
    userPoolId: environment.aws.userPoolId,
    userPoolWebClientId: environment.aws.userPoolWebClientId,
    region: environment.aws.region,
    oauth: {
      domain: environment.aws.userPoolDomain,
      scope: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
      redirectSignIn: environment.aws.oauthRedirectSignIn,
      redirectSignOut: environment.aws.oauthRedirectSignOut,
      clientId: environment.aws.userPoolWebClientId,
      responseType: 'code',
    },
  },
});

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
